export default __webpack_public_path__ + "static/media/service-3-commercial.5e114c83.png";